"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirmaMobileSDK = void 0;
var FirmaBankService_1 = require("./FirmaBankService");
var FirmaFeeGrantService_1 = require("./FirmaFeeGrantService");
var FirmaStakingService_1 = require("./FirmaStakingService");
var FirmaDistributionService_1 = require("./FirmaDistributionService");
var FirmaNftService_1 = require("./FirmaNftService");
var FirmaTokenService_1 = require("./FirmaTokenService");
var FirmaContractService_1 = require("./FirmaContractService");
var FirmaWalletService_1 = require("./FirmaWalletService");
var FirmaUtil_1 = require("./FirmaUtil");
var FirmaGovService_1 = require("./FirmaGovService");
var FirmaChainService_1 = require("./FirmaChainService");
var FirmaSlashingService_1 = require("./FirmaSlashingService");
var FirmaAuthzService_1 = require("./FirmaAuthzService");
var FirmaMobileSDK = /** @class */ (function () {
    function FirmaMobileSDK(Config, Wallet, Bank, FeeGrant, Staking, Distribution, Gov, Nft, Token, Contract, BlockChain, Slashing, Authz) {
        if (Wallet === void 0) { Wallet = new FirmaWalletService_1.FirmaWalletService(Config); }
        if (Bank === void 0) { Bank = new FirmaBankService_1.FirmaBankService(Config); }
        if (FeeGrant === void 0) { FeeGrant = new FirmaFeeGrantService_1.FirmaFeeGrantService(Config); }
        if (Staking === void 0) { Staking = new FirmaStakingService_1.FirmaStakingService(Config); }
        if (Distribution === void 0) { Distribution = new FirmaDistributionService_1.FirmaDistributionService(Config); }
        if (Gov === void 0) { Gov = new FirmaGovService_1.FirmaGovService(Config); }
        if (Nft === void 0) { Nft = new FirmaNftService_1.NftService(Config); }
        if (Token === void 0) { Token = new FirmaTokenService_1.TokenService(Config); }
        if (Contract === void 0) { Contract = new FirmaContractService_1.ContractService(Config); }
        if (BlockChain === void 0) { BlockChain = new FirmaChainService_1.ChainService(Config); }
        if (Slashing === void 0) { Slashing = new FirmaSlashingService_1.SlashingService(Config); }
        if (Authz === void 0) { Authz = new FirmaAuthzService_1.FirmaAuthzService(Config); }
        this.Config = Config;
        this.Wallet = Wallet;
        this.Bank = Bank;
        this.FeeGrant = FeeGrant;
        this.Staking = Staking;
        this.Distribution = Distribution;
        this.Gov = Gov;
        this.Nft = Nft;
        this.Token = Token;
        this.Contract = Contract;
        this.BlockChain = BlockChain;
        this.Slashing = Slashing;
        this.Authz = Authz;
        FirmaUtil_1.FirmaUtil.config = Config;
    }
    return FirmaMobileSDK;
}());
exports.FirmaMobileSDK = FirmaMobileSDK;
